export default __webpack_public_path__ + "4cf777949f967408d1dfa7f38e95f493.png";